import { isObject } from 'util';

export const arrayToString = (arr): string => {
  let str = '';
  if (arr != null) {
    arr.forEach((i, index) => {
      str += i;
      if (index != arr.length - 1) {
        str += ',';
      }
    });
  }
  return str;
};

export const generateRandomString = (lengthOfCode: number = 25) => {
  const possible =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let text = '';
  for (let i = 0; i < lengthOfCode; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export const isNullOrEmptyArray = (val: any) => {
  return (Array.isArray(val) && val.length == 0) || val == null;
};

export const cleanSpacesString = (cadena: string) => {
  return cadena ? cadena.trim().replace(/ +(?= )/g, '') : '';
};

export const formatBytesString = (bytes, decimals?) => {
  /*if (bytes < 1024) return bytes + " Bytes";
  else if (bytes < 1048576) return (bytes / 1024).toFixed(0) + " KB";
  else if (bytes < 1073741824) return (bytes / 1048576).toFixed(2) + " MB";
  else return (bytes / 1073741824).toFixed(1) + " GB";*/

  if (bytes == 0) return '0 Bytes';
  const k = 1024,
    dm = decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const convertQueryParamsStringToJson = queryParams => {
  return queryParams
    .split('&')
    .map(p => p.split('='))
    .reduce((obj, pair) => {
      const [key, value] = pair.map(decodeURIComponent);
      return { ...obj, [key]: value };
    }, {});
};

export const getFieldFromCombo = (
  list: any,
  value: any,
  fieldValue = 'value',
  fieldName = 'text',
) => {
  const found = list.find(x => x[fieldValue] == value);
  return found ? found[fieldName] : '';
};

export const getObjectProperty = (obj, path) => { //isObject
  return path.split(/(\[|\]|\.)/).reduce((x, y) => {
    return '[].'.indexOf(y) > -1
      ? x
      : x === Object(x) && y in x
      ? x[y]
      : undefined;
  }, obj);
};
